<template>
  <div>
    <div id="sidebar" v-if="['edit-campaign','create-campaign'].includes($route.name)" class="sub-sidebar">
      <ul class="side-menu sub-side-menu" :class="{'side-menu-campaign-detail': ['edit-campaign','create-campaign'].includes($route.name)}">
        <li v-if="userCapable" class="side-menu-item" :class="{ active: activeTab === 0 }" @click="activeTab = 0">
          <i class="fas fa-info"></i> <span >Basic Info</span>
        </li>
        <li v-if="userCapable" class="side-menu-item" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
          <i class="fas fa-gift"></i> <span >Campaign Details</span>
        </li>
        <li v-if="userCapable"  class="side-menu-item" :class="{ active: activeTab === 2 }" @click="activeTab = 2">
          <i class="fas fa-envelope-open-text"></i> <span >Data Collection</span>
        </li>
        <li v-if="userCapable" class="side-menu-item" :class="{ active: activeTab === 3 }" @click="activeTab = 3">
          <i class="fas fa-trophy"></i> <span >Scratch-Off Prizes</span>
        </li>
        <li v-if="userCapable && scratchType==='survey'" class="side-menu-item" :class="{ active: activeTab === 6 }" @click="activeTab = 6">
          <i class="fas fa-poll"></i> <span >Survey Card</span>
        </li>
        <li v-if="userCapable" class="side-menu-item dropdown-toggle" :class="{ active: activeTab === 4 }" @click="activeTab = 4">
          <i class="fas fa-sliders-h"></i> <span >Customization</span>
        </li>
        <ul class="sub-side-menu-sub" v-if="activeTab === 4">
          <li :class="{ active: selected_layout === 0 }" @click="selected_layout = 0">Background Style</li>
          <li :class="{ active: selected_layout === 1 }" @click="selected_layout = 1">Main Title Style</li>
          <li :class="{ active: selected_layout === 2 }" @click="selected_layout = 2">Sub Title Style</li>
          <li :class="{ active: selected_layout === 3 }" @click="selected_layout = 3">Form Input Labels Text Style</li>
          <li :class="{ active: selected_layout === 4 }" @click="selected_layout = 4">Submit Button Text Style</li>
          <li :class="{ active: selected_layout === 5 }" @click="selected_layout = 5">Submit Button Background Style</li>
          <li :class="{ active: selected_layout === 6 }" @click="selected_layout = 6">Submit Sub Text Style</li>
          <li :class="{ active: selected_layout === 7 }" @click="selected_layout = 7">Custom Link Sub Title Style</li>
          <li :class="{ active: selected_layout === 8 }" @click="selected_layout = 8">Custom Link Button Text Style</li>
          <li :class="{ active: selected_layout === 9 }" @click="selected_layout = 9">Custom Link Button Background Style</li>
          <li :class="{ active: selected_layout === 10 }" @click="selected_layout = 10">Privacy Policy Text Style</li>
          <li :class="{ active: selected_layout === 11 }" @click="selected_layout = 11">Scratch Congratulations Style</li>
          <li :class="{ active: selected_layout === 12 }" @click="selected_layout = 12">Scratch-Off Card Background Style</li>
          <li :class="{ active: selected_layout === 13 }" @click="selected_layout = 13">Scratch-Off Card Cover Image</li>
          <li :class="{ active: selected_layout === 14 }" @click="selected_layout = 14">Rate Us Title Color</li>
        </ul>

        <li class="side-menu-item" :class="{ active: activeTab === 5 }" @click="activeTab = 5">
          <i class="fas fa-user-shield"></i> <span >Privacy Policy</span>
        </li>
      </ul>
    </div>
    <div class="workspace" :class="{'workspace-campaign-detail' : ['edit-campaign','create-campaign'].includes($route.name)}">
    <div class="cca">
      <!--<div class="dash-nav">
        <div class="dash-tabs">
          <div class="tab" :class="[activeTab === 0 ? 'active' : '']" @click="activeTab = 0">Basic Info</div>
          <div class="tab" :class="[activeTab === 1 ? 'active' : '']" @click="activeTab = 1">Campaign Details</div>
          <div class="tab" :class="[activeTab === 2 ? 'active' : '']" @click="activeTab = 2">Data Collection</div>
          <div class="tab" :class="[activeTab === 3 ? 'active' : '']" @click="activeTab = 3">Scratch-Off Prizes</div>
          <div class="tab" :class="[activeTab === 4 ? 'active' : '']" @click="activeTab = 4">Customization</div>
          <div class="tab" :class="[activeTab === 5 ? 'active' : '']" @click="activeTab = 5">Privacy Policy</div>
          <div v-if="scratchType==='survey'" class="tab" :class="[activeTab === 6 ? 'active' : '']" @click="activeTab = 6">Survey Card</div>
        </div>
      </div>-->

    <div class="section-heading">
      <h2 :class="campaign_name_focused ? 'editing-now' : '' ">{{ (name) ? name : 'New Campaign'}}</h2>
      <div class="al-button" @click="submitForm">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M15.2499 8.375H11.1249V4.25C11.1249 3.74297 10.7153 3.33333 10.2083 3.33333H9.29159C8.78455 3.33333 8.37492 3.74297 8.37492 4.25V8.375H4.24992C3.74289 8.375 3.33325 8.78464 3.33325 9.29167V10.2083C3.33325 10.7154 3.74289 11.125 4.24992 11.125H8.37492V15.25C8.37492 15.757 8.78455 16.1667 9.29159 16.1667H10.2083C10.7153 16.1667 11.1249 15.757 11.1249 15.25V11.125H15.2499C15.757 11.125 16.1666 10.7154 16.1666 10.2083V9.29167C16.1666 8.78464 15.757 8.375 15.2499 8.375Z" fill="white"/>
      </svg> Save & Update</div>
    </div>
    <div class="create-campaign-two-section" v-if="showLayout">
       <div class="cc-tab-view" :class="activeTab === 0 ? 'active-tab' : 'inactive-tab'">
          <basic-info ref="basic_info" :data-val="basicInfoDefault" :update="update_basic_info" />
        </div>
        <div class="cc-tab-view" :class="activeTab === 1 ? 'active-tab' : 'inactive-tab'">
          <campaign-details ref="campaign_info" :data-val="campaignInfoDefault" :update="update_campaign_details"/>
        </div>
        <div class="cc-tab-view"  :class="activeTab === 2 ? 'active-tab' : 'inactive-tab'">
          <data-collection ref="data_collection" :data-val="dataInfoDefault" :update="update_data_details"/>
        </div>
        <div class="cc-tab-view"  :class="activeTab === 3 ? 'active-tab' : 'inactive-tab'">
          <scratch-off-prizes ref="prizes_info" :data-val="prizeInfoDefault" :update="update_prize_details" />
        </div>
        <div class="cc-tab-view"  :class="activeTab === 4 ? 'active-tab' : 'inactive-tab'">
          <customization :data-val="customizationDefault" :selected_layout="selected_layout"/>
        </div>
        <div class="cc-tab-view"  :class="activeTab === 5 ? 'active-tab' : 'inactive-tab'">
          <privacy ref="privacy_info" :data-val="privacyDefault" :update="update_privacy" />
        </div>
        <div v-if="scratchType==='survey'" class="cc-tab-view"  :class="activeTab === 6 ? 'active-tab' : 'inactive-tab'">
          <survey-card ref="survey_card" :data-val="surveyCardDefault" :update="update_surveyCard" />
        </div>
        <div class="flex-area" style="float: right;float: right; position: fixed; left: 70%; top: 11%;">
          <div class="qr-field w-100">
            <div class="preview-wrapper">
          <h2 class="new-preview-flex">Preview</h2>
          <div class="flex new-flex">
            <span class="new-span">Form</span>
            <vs-switch class="switch-button mx-2" v-model="preview_switch" />
            <span class="new-span">Scratch</span>
          </div>
          <div id="campaign-preview">
            <div class="campaign-live-preview" ref="preview"
                 :style="campaign_theme ? main_style : ''" v-if="!preview_switch">
              <section id="campaign-logo" class="form-module">
                <div class="campaign-logo" ref="campaignLogo">
                  <img :src="(logo_id) ? `https://restapi.authorizelocal.com/api/posts/photo/${this.logo_id}` : '/img/yourlogohere.jpg'"/>
                </div>
              </section>
              <section id="campaign-slogan" class="form-module" ref="campaignSlogan">
                <h2 :style="campaign_theme ? slogan_style : ''" :class="campaign_slogan_focused ? 'editing-now' : '' ">{{ (title) ? title : 'Campaign Main Title' }}</h2>
              </section>
              <section id="campaign-award" class="form-module" ref="campaignAward">
                <p><span :style="campaign_theme ? award_style : ''" :class="campaign_award_focused ? 'editing-now' : '' " class="popout">{{ (offer) ? offer : 'Campaign Award Title' }}</span></p>
              </section>
              <section id="campaign-award-visual" class="form-module" ref="campaignAwardVisual">
                <img :src="(campaign_image_id) ? `https://restapi.authorizelocal.com/api/posts/photo/${this.campaign_image_id}` : '/img/awardvisual.jpg'"/>
              </section>
              <section id="data-collection" class="form-module" ref="fieldList">
                <div v-for="(option, option_index) in fieldList" :key="option_index" >

                    <label :style="campaign_theme ? label_style : ''">{{fieldnames.filter(x => x.code === option)[0].name}}
                      <input class="al-input" :type="fieldnames.filter(x => x.code === option)[0].type" :placeholder="fieldnames.filter(x => x.code === option)[0].name"></label>
                </div>
                <div v-for="(field, field_index) in customFieldList" :key="`custom${field_index}`" v-if="field.value">
                  <label :style="campaign_theme ? label_style : ''">{{ field.name }}
                  <phone-mask-input
                    autoDetectCountry
                    v-if="field.code === 'phone'" :ref="`${field.code}`"
                    showFlag
                    wrapperClass="relative"
                    inputClass="al-input"
                    flagClass="phone-flag"
                  />

                  <textarea
                    rows="5"
                    class="al-input textarea"
                    v-else-if="field.code === 'longtext'" :placeholder="field.name" />

                  <input
                    v-else
                    class="al-input"
                    :type="field.type" :placeholder="field.name">
                  </label>
                </div>
              </section>
              <section class="form-agreement" ref="privacy">
                <p :style="campaign_theme ? privacy_primary : ''" style="text-align:justify">Your contact information will only be used to keep you informed of upcoming exciting promotions and special events. We will never sell or distribute your information.</p>
                <div class="form-agreement-check">
                  <div><input type="checkbox" v-model="check"/></div>
                  <div :style="campaign_theme ? privacy_primary : ''">I've read and understand the <a  :style="campaign_theme ? privacy_secondary : ''" class="cursor-pointer" @click="showPrivacy">{{ activeUserInfo.company.name }}</a>'s Privacy Policy and <a :style="campaign_theme ? privacy_secondary : ''" href="https://authorizelocal.com/portal-privacy-policy/" target="_blank">Authorize Local's Privacy Policy</a></div>
                </div>
              </section>
              <section class="submit-button" ref="submitButton">
                <div :style="campaign_theme ? submit_style : ''" class="al-button mb-4" >{{ submit_data.text }}</div>
                <h3 class="submit-button-sub-text" :style="campaign_theme ? submit_subtext_style : ''">{{submit_data.subtext}}</h3>
              </section>
              <section v-if="custom_link.is_active" class="custom-link" ref="customLink">
                <a :style="campaign_theme ? custom_link_style : ''" href="#" class="al-button" target="_blank">{{ custom_link.button_title }}</a>
                <h3 :style="campaign_theme ? custom_link_style_title : ''">{{custom_link.title}}</h3>
              </section>
              <section class="review" ref="Rate">
<!--                <h2 :style="campaign_theme ? rate_style : ''">Rate Us</h2>-->
                <span>★★★★★</span>
                <div class="al-button google-button">
                  <img src="../../../assets/images/google_g.png" /> Rate on Google
                </div>
              </section>
                <vue-bottom-sheet ref="sheet" class="bottom-sheet">
                <p v-html="privacy"/>
              </vue-bottom-sheet>
            </div>
            <div class="campaign-live-preview" v-else>
              <scratch-preview ref="congratswrapper" v-if="showPreview" :show-prize-placeholder="showScratch" :show-congrats-placeholder="showCongrats" :preview-prize="previewPrize"/>
            </div>
          </div>
        </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import ScratchPreview from './components/ScratchPreview'
import BasicInfo from './components/BasicInfo'
import CampaignDetails from './components/CampaignDetails'
import DataCollection from './components/DataCollection'
import ScratchOffPrizes from './components/ScratchOffPrizes'
import Customization from './components/Customization'
import UploadImage from '../../../layouts/components/navbar/UploadImage'
import Privacy from './components/Privacy'
import  VueBottomSheet from '@webzlodimir/vue-bottom-sheet'
import PhoneMaskInput from 'vue-phone-mask-input'
import SurveyCard from './components/SurveyCard.vue'
export default {
  props: {
    id: {
      type: String
    }
  },
  data () {
    return {
      previewPrize: null,
      showScratch: true,
      showCongrats: false,
      create: true,
      init: true,
      sheet: false,
      check: false,
      preview_switch: true,
      showLayout: false,
      showPreview: true,
      campaign_name_focused: false,
      campaign_award_focused: false,
      campaign_slogan_focused: false,
      expires: '1 week',
      activeTab: 0,
      dataImg: require('@/assets/images/logo/logo.png'),
      uploadImg: null,
      custom_link: null,
      submit_data: null,
      name: '',
      endDate: '',
      logo_id: '',
      scratchType: 'normal',
      rate_available: true,
      title: '',
      offer: '',
      award_name: '',
      campaign_image_id: '',
      privacy: '',
      fieldnames: [
        {
          name: 'Name',
          type: 'text',
          code: 'name',
          value: false
        },
        {
          name: 'Phone Number',
          code: 'phone',
          type: 'phone',
          value: false
        },
        {
          name: 'Email',
          code: 'email',
          type: 'email',
          value: false
        },
        {
          name: 'Your Website',
          code: 'website',
          type: 'website',
          value: false
        },
        {
          name: 'Birthday',
          code: 'birthday',
          type: 'date',
          value: false
        },
        {
          name: 'Address',
          code: 'address',
          type: 'text',
          value: false
        }
      ],
      fieldList: ['email'],
      customFieldList: [],
      prizeList: [],
      questionList: [],
      prizeDefault: {
        name: '',
        rate: 0,
        image_id: ''
      },
      basicInfoDefault: {
        name: '',
        endDate: '',
        logo_id: '',
        rate_available: true,
        scratchType: 'normal'
      },
      privacyDefault: {
        privacy: ''
      },
      campaignInfoDefault: {
        offer: '',
        title: '',
        award_name: '',
        campaign_image_id: '',
        expires: '1 week',
        custom_link: {
          title: 'Custom Link',
          link: '',
          button_title: 'Custom Link',
          is_active: false
        },
        submit_data: {
          text: 'Submit & Win!',
          subtext: 'Submit sub text'
        }
      },
      dataInfoDefault: {
        fieldList: ['email']
      },
      surveyCardDefault: {
        questionList: []
      },
      prizeInfoDefault: {
        prizeList: []
      },
      customizationDefault: {
        main: '',
        scratch: '',
        award: '',
        slogan: ''
      },
      post_id: null,
      previousRef: null,
      selected_layout: -1
    }
  },
  components: {
    SurveyCard,
    Privacy,
    PhoneMaskInput,
    ScratchPreview,
    UploadImage,
    BasicInfo,
    CampaignDetails,
    DataCollection,
    ScratchOffPrizes,
    Customization,
    VueBottomSheet
  },
  metaInfo () {
    return {
      title: `${this.id ? 'Edit' : 'Create'} Campaign`,
      titleTemplate: '%s - AuthorizeLocal',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Create a campaign for your business'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Local SEO Solutions'
        }
      ]
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  beforeMount () {
  },
  mounted () {
    this.$store.commit('SET_EDITING_NOW', null)
    if (this.id) {
      this.getPostDetail()
    } else {
      this.showLayout = true
    }
  },
  watch: {
    scrollY () {
      console.log('scroll Y', this.scrollY)
    },
    campaign_theme () {
      console.log('theme', this.campaign_theme)
    },
    activeTab () {
      if (this.activeTab === 4) {
        this.showScratch = true
        this.preview_switch = true
        this.showPreview = false
        setTimeout(() => {
          this.showPreview = true
        }, 500)
      } else if (this.activeTab === 3) {
        this.showScratch = false
        this.preview_switch = true
      } else {
        this.preview_switch = false
      }
      this.resetViewRefs()
    },
    editing_now () {
      console.log('editing-now', this.editing_now)
      if (this.editing_now) {
        this.focusOnView(this.editing_now)
      } else {
        this.resetViewRefs()
      }
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    userCapable () {
      let result = true
      this.activeUserInfo.subscriptions.map(sub => {
        if (sub.plan.product.id === 'prod_LxaiP3NvLRaWld') {
          result = true
        }
      })
      return result
    },
    scrollY () {
      return this.$store.state.scrollY
    },
    scratch_style () {
      if (this.campaign_theme) {
        return `background: ${this.campaign_theme.scratch}`
      } else {
        return ''
      }
    },
    main_style () {
      if (this.campaign_theme.main) {
        if (this.isObject(this.campaign_theme.main)) {
          return `background: url(${this.getImage(this.campaign_theme.main.url)})`
        } else if (this.campaign_theme.main !== '') {
          return `background: ${this.campaign_theme.main}`
        }
      }
      return ''
    },
    submit_style () {
      if (this.campaign_theme.submit) {
        return `background: ${this.campaign_theme.submit.background}; color: ${this.campaign_theme.submit.color}; font-size: ${this.campaign_theme.submit.size}px; font-weight: ${this.campaign_theme.submit.weight};`
      } else {
        return ''
      }
    },
    submit_subtext_style () {
      if (this.campaign_theme.submit) {
        return `color: ${this.campaign_theme.submit_subtext.color}; font-size: ${this.campaign_theme.submit_subtext.size}px; font-weight: ${this.campaign_theme.submit_subtext.weight};`
      } else {
        return ''
      }
    },
    custom_link_style () {
      if (this.campaign_theme.custom_link) {
        return `background: ${this.campaign_theme.custom_link.background}; color: ${this.campaign_theme.custom_link.color}; font-size: ${this.campaign_theme.custom_link.size}px; font-weight: ${this.campaign_theme.custom_link.weight};`
      } else {
        return ''
      }
    },
    custom_link_style_title () {
      if (this.campaign_theme.custom_link) {
        return `color: ${this.campaign_theme.custom_link.title.color}; font-size: ${this.campaign_theme.custom_link.title.size}px; font-weight: ${this.campaign_theme.custom_link.title.weight};`
      } else {
        return ''
      }
    },
    rate_style () {
      if (this.campaign_theme.rate) {
        return `color: ${this.campaign_theme.rate.color}; font-size: ${this.campaign_theme.rate.size}px; font-weight: ${this.campaign_theme.rate.weight};`
      } else {
        return ''
      }
    },
    privacy_primary () {
      if (this.campaign_theme.privacy) {
        return `color: ${this.campaign_theme.privacy.primary_color}; font-size: ${this.campaign_theme.privacy.primary_size}px; font-weight: ${this.campaign_theme.privacy.primary_weight};`
      } else {
        return ''
      }
    },
    privacy_secondary () {
      if (this.campaign_theme.privacy) {
        return `color: ${this.campaign_theme.privacy.secondary_color}; font-size: ${this.campaign_theme.privacy.secondary_size}px; font-weight: ${this.campaign_theme.privacy.secondary_weight};`
      } else {
        return ''
      }
    },
    label_style () {
      if (this.campaign_theme.labels) {
        return `color: ${this.campaign_theme.labels.color}; font-size: ${this.campaign_theme.labels.size}px; font-weight: ${this.campaign_theme.labels.weight};`
      } else {
        return ''
      }
    },
    award_style () {
      if (this.campaign_theme.award) {
        return `color: ${this.campaign_theme.award.color}; font-size: ${this.campaign_theme.award.size}px; font-weight: ${this.campaign_theme.award.weight};`
      } else {
        return ''
      }
    },
    slogan_style () {
      if (this.campaign_theme.slogan) {
        return `color: ${this.campaign_theme.slogan.color}; font-size: ${this.campaign_theme.slogan.size}px; font-weight: ${this.campaign_theme.slogan.weight};`
      } else {
        return ''
      }
    },
    post_detail () {
      return this.$store.state.post_detail
    },
    campaign_theme () {
      return this.$store.state.campaign_theme
    },
    editing_now () {
      return this.$store.state.editing_now
    }
  },
  methods: {
    showPrivacy () {
      if (!this.sheet) {
        this.$refs.sheet.open()
      } else {
        this.$refs.sheet.close()
      }
      this.sheet = !this.sheet
    },
    focusOnView (ref) {
      this.$nextTick(() => {
        if (ref === 'scratchBackground') {
          this.showScratch = false
          this.preview_switch = true
          this.showPreview = false
          setTimeout(() => {
            this.showPreview = true
          }, 500)
        } else if (ref === 'scratchCover') {
          this.preview_switch = true
          this.showScratch = true
          this.showPreview = false
          setTimeout(() => {
            this.showPreview = true
          }, 500)
        } else if (ref === 'congrats') {
          console.log('ref congrats')
          this.showCongrats = true
          this.preview_switch = true
          this.showPreview = false
          setTimeout(() => {
            this.showPreview = true
            //this.$refs[ref].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest'  })
            this.$refs.congratswrapper.$refs.congrats.classList.toggle('editing-now')
            this.previousRef = ref
          }, 500)
        } else {
          this.preview_switch = false
          console.log('preview', ref)
          setTimeout(() => {
            if (ref) {
              this.$refs[ref].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest'  })
              this.$refs[ref].classList.toggle('editing-now')
              this.previousRef = ref
            }
          }, 500)
        }

        console.log('editing-now', ref, this.$refs[ref])
        if (this.previousRef) {
          this.$refs[this.previousRef].classList.toggle('editing-now')
        }
      })

    },
    resetViewRefs () {
      if (this.previousRef) {
        this.$refs[this.previousRef].classList.toggle('editing-now')
        this.previousRef = null
      }
    },
    getImage (url) {
      return `https://restapi.authorizelocal.com/api/posts/photo/${url}`
    },
    isObject (a) {
      return (!!a) && (a.constructor === Object)
    },
    update_privacy (privacy) {
      this.privacy = privacy
      this.privacyDefault.privacy = privacy
    },
    update_basic_info (name, campaign_name_focused, logo_id, rate_available, endDate, scratchType) {
      this.campaign_name_focused = campaign_name_focused
      this.name = name
      this.endDate = endDate
      this.logo_id = logo_id
      this.scratchType = scratchType
      this.rate_available = rate_available
      this.basicInfoDefault.name = name
      this.basicInfoDefault.endDate = endDate
      this.basicInfoDefault.logo_id = logo_id
      this.basicInfoDefault.rate_available = rate_available
      this.basicInfoDefault.scratchType = scratchType
    },
    update_campaign_details (offer, title, award_name, campaign_image_id, expires, custom_link, submit_data) {
      this.campaign_image_id = campaign_image_id
      this.offer = offer
      this.title = title
      this.award_name = award_name
      this.expires = expires
      this.custom_link = custom_link
      this.submit_data = submit_data

      this.campaignInfoDefault.offer = offer
      this.campaignInfoDefault.title = title
      this.campaignInfoDefault.expires = expires
      this.campaignInfoDefault.award_name = award_name
      this.campaignInfoDefault.campaign_image_id = campaign_image_id
      this.campaignInfoDefault.custom_link = custom_link
      this.campaignInfoDefault.submit_data = submit_data
    },
    update_data_details (fieldList, customList) {
      this.fieldList = fieldList
      console.log('update data details', customList)
      this.customFieldList = customList
      this.dataInfoDefault.fieldList = fieldList
      this.dataInfoDefault.customFieldList = customList
    },
    update_surveyCard (questionList) {
      this.questionList = questionList

      this.surveyCardDefault.questionList = questionList
    },
    update_prize_details (prizeList) {
      this.prizeList = prizeList

      this.prizeInfoDefault.prizeList = prizeList

      if (prizeList.length > 0) {
        this.previewPrize = prizeList[0]
      }
    },
    getPostDetail () {
      const payload = {
        slug: this.id
      }
      this.$store.dispatch('getPostSlugUser', payload)
        .then(() => {
          console.log('success')
          this.setPostInfo()
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log('error')
          console.log(error)
          this.$router.push('/campaigns').then(() => {
            location.reload()
          })
        })
    },
    setPostInfo () {
      const { _id, name, endDate, logo_id, scratchType, title, offer, award_name, campaign_image_id, fieldList, customFieldList, prizeList, questionList, privacy, campaign_theme, expires, custom_link, submit_data, rate_available } = JSON.parse(JSON.stringify(this.post_detail))
      this.name = name
      this.scratchType = scratchType
      this.endDate = endDate
      this.logo_id = logo_id
      this.title = title
      this.offer = offer
      this.award_name = award_name
      this.campaign_image_id = campaign_image_id
      this.fieldList = fieldList
      this.customFieldList = customFieldList
      this.prizeList = prizeList
      this.questionList = questionList
      this.post_id = _id
      this.expires = expires
      this.privacy = privacy
      this.rate_available = rate_available

      if (campaign_theme) {
        this.customizationDefault = campaign_theme
        this.$store.commit('SET_CAMPAIGN_THEME', campaign_theme)
      }

      this.basicInfoDefault.name = name
      this.basicInfoDefault.endDate = endDate
      this.basicInfoDefault.logo_id = logo_id
      this.basicInfoDefault.rate_available = rate_available
      this.basicInfoDefault.scratchType = scratchType
      this.campaignInfoDefault.offer = offer
      this.campaignInfoDefault.title = title
      this.campaignInfoDefault.award_name = award_name
      this.campaignInfoDefault.expires = expires
      this.campaignInfoDefault.campaign_image_id = campaign_image_id
      this.privacyDefault.privacy = privacy

      if (custom_link) {
        this.custom_link = custom_link
        this.campaignInfoDefault.custom_link.link = custom_link.link
        this.campaignInfoDefault.custom_link.title = custom_link.title
        this.campaignInfoDefault.custom_link.button_title = custom_link.button_title
        this.campaignInfoDefault.custom_link.is_active = custom_link.is_active
      }

      if (submit_data) {
        this.submit_data = submit_data
        this.campaignInfoDefault.submit_data.text = submit_data.text
        this.campaignInfoDefault.submit_data.subtext = submit_data.subtext

      }

      this.dataInfoDefault.fieldList = fieldList
      this.dataInfoDefault.customFieldList = customFieldList
      this.prizeInfoDefault.prizeList = prizeList
      this.surveyCardDefault.questionList = questionList

      console.log('tabs data', this.basicInfoDefault, this.campaignInfoDefault, this.dataInfoDefault, this.prizeInfoDefault)

      this.fieldList.map((item) => {
        console.log('checking item', item)
        this.fieldnames.filter((field, index) => {
          if (item === field.code) {

            this.fieldnames[index].value = true
            console.log('item found', this.fieldnames[index])
          }
          return field
        })
      })

      this.showLayout = true
    },
    prizeNameChange (prize, e) {
      prize.name = e.target.value
    },
    campaignUploaded (result) {
      console.log('campaign', result)
      this.campaign_image_id = result
    },
    logoUploaded (result) {
      console.log('logo', result)
      this.logo_id = result
    },
    imageUploaded (result, index) {
      console.log(index, result)
      this.prizeList[index].image_id = result

      console.log(this.prizeList[index])
    },
    addPrize () {
      this.prizeList.push({
        name: '',
        rate: '',
        image_id: '',
        text_enabled: false
      })
      console.log(this.prizeList)
    },
    onCheckChange (option, e) {
      console.log('check change')
      console.log(e.target.value)
      const index = this.fieldList.findIndex(x => x === e.target.value)
      //const name_index = this.fieldnames.findIndex(x => x === e.target.value)
      // here you can check specific property for an object whether it exist in your array or not

      index === -1 ? this.fieldList.push(e.target.value) : this.fieldList.splice(index, 1)
      //this.fieldnames[name_index].value = !this.fieldnames[name_index].value
      console.log(this.fieldList)
    },
    uploadImage (callback) {
      if (this.uploadImg !== null) {

        const img_obj = {
          file: this.uploadImg
        }
        console.log('uploading image', img_obj)
        this.$store.dispatch('api/uploadImage', img_obj,  event => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        }).then((response) => {
          console.log('upload image', response)
          callback(response)
          this.$vs.notify({
            title: 'Success',
            text: response.data.message,
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
        }).catch(err => {
          console.log(err)
          this.$vs.notify({
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.$vs.loading.close()
        })
      }
    },
    submitForm () {
      console.log('form submit basic_info', this.$refs.campaign_info)

      this.$vs.loading()
      this.$refs.basic_info.$validator.validateAll().then(result => {
        if (result) {
          this.$refs.campaign_info.$validator.validateAll().then(result => {
            if (result) {
              this.$refs.data_collection.$validator.validateAll().then(result => {
                if (result) {
                  this.$refs.prizes_info.$validator.validateAll().then(result => {
                    if (result) {
                      console.log('prize validation', this.prizeList)
                      if (this.prizeList.length === 0) {
                        this.activeTab = 3
                        this.$vs.notify({
                          title: 'Error',
                          text: 'No prize found',
                          color: 'warning',
                          iconPack: 'feather',
                          icon: 'icon-alert-circle'
                        })
                        this.$refs.prizes_info.showValidationError()
                        this.$vs.loading.close()
                        //this.scrollToError()
                      } else {
                        this.$refs.privacy_info.$validator.validateAll().then(result => {
                          if (result) {
                            const post = {
                              name: this.name,
                              endDate: this.endDate,
                              logo_id: this.logo_id,
                              scratchType: this.scratchType,
                              title: this.title,
                              offer: this.offer,
                              award_name: this.award_name,
                              campaign_image_id: this.campaign_image_id,
                              fieldList: this.fieldList,
                              customFieldList: this.customFieldList,
                              expires: this.expires,
                              prizeList: this.prizeList,
                              questionList: this.questionList,
                              privacy: this.privacy,
                              custom_link: this.custom_link,
                              submit_data: this.submit_data,
                              rate_available: this.rate_available
                            }
                            if (this.campaign_theme) {
                              post.campaign_theme = this.campaign_theme
                            }
                            let req_type = 'savePost'
                            if (this.post_id) {
                              req_type = 'patchPost'
                              post.id = this.post_id
                            }
                            this.$vs.loading()
                            this.$store.dispatch(req_type, post)
                              .then(result => {
                                if (result) {
                                  console.log(result)
                                  this.$vs.notify({
                                    title: 'Success',
                                    text: 'Information saved successfully',
                                    color: 'success',
                                    iconPack: 'feather',
                                    icon: 'icon-check'
                                  })
                                  this.$vs.loading.close()
                                  //this.$router.push({name: 'mycards'})
                                  //this.$router.push('/campaigns')
                                }
                              })
                              .catch(error => {
                                this.$vs.notify({
                                  title: 'Error',
                                  text: error.message,
                                  color: 'warning',
                                  iconPack: 'feather',
                                  icon: 'icon-alert-circle'
                                })
                                this.$vs.loading.close()
                              })
                          } else {
                            this.activeTab = 5
                            this.scrollToError()
                            this.$vs.loading.close()
                          }
                        })
                      }
                    } else {
                      this.activeTab = 3
                      this.scrollToError()
                      this.$vs.loading.close()
                    }
                  })
                } else {
                  this.activeTab = 2
                  this.scrollToError()
                  this.$vs.loading.close()
                }
              })
            } else {
              this.activeTab = 1
              this.scrollToError()
              this.$vs.loading.close()
            }
          })
        } else {
          this.activeTab = 0
          this.scrollToError()
          this.$vs.loading.close()
        }
      })

    },
    scrollToError () {
      const asd = this.$validator.errors.items[this.$validator.errors.items.length - 1]
      console.log('asd', this.$validator.errors.items, asd)
      let ref = this.$validator.errors.items[this.$validator.errors.items.length - 1].field
      if (ref.includes('prize') && ref.includes('image')) {
        ref = ref.replace('_image', '')
      }
      console.log('ref', this.$el.querySelector(`[data-vv-name='${ref}']`), ref)
      setTimeout(() => {
        this.$el.querySelector(`[data-vv-name='${ref}']`).scrollIntoView({ behavior: 'smooth' })
      }, 500)
    }
  }
}
</script>
<style lang="scss">
.bottom-sheet {
  z-index: 1 !important;

  .bottom-sheet__backdrop {
    margin: 70px 0 0 50px;
  }
  .bottom-sheet__content {
    margin: 0 0 0 50px;
    height: 60vh !important;
    p {
      padding: 0 10px;
    }
  }
}
.form-agreement{
  display:flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  font-size:11px;
  margin:20px 0;
  div{
    padding:5px;
  }
  input {
    width:25px;
    height:25px;
    margin-bottom:0;
  }
  a {
    color:#f08028;
  }
  .al-button{
    font-size:26px;
  }
  .form-agreement-check{
    display:flex;
    justify-content: flex-start;
    align-items:center;
  }
}
.active-tab {
  display: block;
}
.inactive-tab {
  display: none;
}
.create-campaign-two-section{
  display:flex;
  justify-content: space-between;
}

.dash-nav{
  .al-button{
    height:50px;
  }
  display:flex;
  justify-content: space-between;
  align-items:center;
  padding:0 20px 0 0;
}
.workspace{
  overflow-y:hidden;
}
.cca{
  height:100%;
}
.cc-tab-view{
  &::-webkit-scrollbar{
  display:none;
  }
  overflow-y:scroll;
  padding:20px 20px 200px 20px;
  width:50%;
}
.preview-wrapper {
  .vs-switch{
  background-color:#005488;
  }
}
.preview-wrapper{
  .vs-switch-active{
  background-color:#f28129;
  }
}
.preview-wrapper{
  .vs-circle-switch{
    background-color:#fff;

  }
}
.workspace-campaign-detail {
  min-width: 1060px;
}
.sub-sidebar {
  background-color: #013A5A !important;
  width: 217px !important;
  float: left;
  min-height: 1550px;

}
.sub-sidebar > ul > li {
  font-size: 12px;
  width: 217px;
  padding: 22px 20px !important;
}
.sub-sidebar > .side-menu >  li:hover {
  background-color: #00527A;
}
.workspace-campaign-detail {
  background-color: transparent;
  border: 0;
}
.sub-side-menu {
  margin: 0 !important;
}
.sub-side-menu-sub {
  padding: 20px 0;
}
.sub-side-menu-sub > li {
  margin-left: 40px;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 400;
  list-style-type: disc;
}
.sub-side-menu-sub > li:hover {
  color: #fff;
  cursor: pointer;
}
.sub-side-menu-sub > .active {
  color: #fff;
}
.section-heading {
  width: 58% !important;
  border-bottom: none !important;
  padding-left: 20px;
  padding-bottom: 40px;
}
.section-heading > h2 {
  font-size: 24px;
  color: #003451;
  font-variant-numeric: lining-nums proportional-nums;

  /* Heading Styles/H2 */
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  line-height: 40px; /* 142.857% */
}
.cc-tab-view {
  width: 60% !important;
  padding-left: 20px
}
.section-heading > .al-button {
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  display: flex;
  padding: 10px 12px;
  height: 44px;
}
.al-input {
  display: flex;
  /* width: 471px; */
  padding: 16px;
  align-items: center;
  gap: 5px;
  border-radius: 12px;
  border: 1px solid #AEB8B8;
  font-weight: 600;
}
.al-select {
  border-radius: 8px 8px 0px 0px;
  background: #FFF;
  box-shadow: 0px 3px 12px 0px rgba(0, 52, 81, 0.15);
  width: 100%;
  height: 48px;
  padding-left: 16px;
  -moz-appearance: listbox;
  -webkit-appearance: listbox;
  font-weight: 600;
}
.al-select:after {
  position: absolute;
  content: "";
  top: 14px;
  right: 10px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-color: #003451 transparent transparent transparent;
}

#campaign-preview.inside-creator {
  right: 0;

}
#campaign-preview {
  margin-top: 17px;

}
.uploader-top {
  min-height: 50px;
}
.new-flex {
  padding-left: 72px
}
.new-preview-flex {
  padding-left: 100px;
  color: var(--Main-Color-Main-100, #003451);
  font-variant-numeric: lining-nums proportional-nums;

  /* Heading Styles/H3 */
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 150% */
}
.new-span {
  color: var(--Main-Color-Main-80, #006495);
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.32px;
}
  .vs-switch{
    background-color:#005488;
    border-radius: 12px
  }
  .vs-switch-active{
    background-color:#f28129;
  }
.switch-button .vs-circle-switch {
    background: #fff
  }
.flex-area {
  width: 600px;
}
</style>
